import { render } from "./KROwnerActivity.vue?vue&type=template&id=369c5f50"
import script from "./KROwnerActivity.vue?vue&type=script&lang=js"
export * from "./KROwnerActivity.vue?vue&type=script&lang=js"
script.render = render

export default script